<template>
  <div>
   <!-- <button type="button" class="btn btn-dark" @click="initQuiz()">Start Quiz</button> -->
    <div class="row">
         <div class="col-sm-4"></div>
          <div class="col-sm-4">
              <b-button block squared @click="initQuiz()" variant="outline-dark" size="lg">Start Quiz</b-button>
 
          </div>
                    <div class="col-sm-4">
</div>
    </div>
  </div>
</template>

<script>
import db from '../../../lib/db'
export default {
  name: 'StartButton',
  props: {
    msg: String
  },
  data () {
      return {

      }
  },
  methods: {
      initQuiz: function (){
        
        this.$emit('startQuiz')
        console.log('generate quiz')
        // const hello = db.callFunc('helloWorldc');
        // hello().then(function (result) {
        //     console.log('resutl ', result)
        // })
    }
  },
  create () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
